import { Icon } from "@iconify/react";
import { pascalCase } from "pascal-case";
import React, { useEffect, useState } from "react";
import { Breadcrumb } from "react-bootstrap";

const PageNav = () => {
  const path = window.location.pathname.split("/")[1];
  const [breadcrumb, setBreadcrumb] = useState("");

  useEffect(() => {
    if (path.includes("detail")) {
      setBreadcrumb("Survey Details");
    } else {
      setBreadcrumb(pascalCase(path));
    }
  }, [path]);

  return (
    <Breadcrumb>
      <Breadcrumb.Item href="/dashboard">
        <i>
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.10483 13.8476V11.8031C6.10482 11.2831 6.52877 10.8606 7.05403 10.8571H8.97808C9.50585 10.8571 9.93369 11.2806 9.93369 11.8031V11.8031V13.854C9.93357 14.2955 10.2895 14.6563 10.7354 14.6667H12.0181C13.2968 14.6667 14.3334 13.6405 14.3334 12.3746V12.3746V6.55857C14.3265 6.06056 14.0903 5.59291 13.692 5.2887L9.30517 1.79021C8.53664 1.18105 7.44416 1.18105 6.67563 1.79021L2.30804 5.29505C1.90819 5.59803 1.67161 6.06645 1.66669 6.56492V12.3746C1.66669 13.6405 2.70327 14.6667 3.98196 14.6667H5.26466C5.72159 14.6667 6.092 14.3 6.092 13.8476V13.8476"
              stroke="#E6F0F0"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </i>
      </Breadcrumb.Item>
      {path.includes("detail") && (
        <Breadcrumb.Item className="ms-2 cta-back" href="/surveys">
          <Icon icon="material-symbols:arrow-back-ios-rounded" />
        </Breadcrumb.Item>
      )}
      {/* <Breadcrumb.Item className="ms-2" href="/dashboard">
        <Link to="/dashboard">Dashboard</Link>
      </Breadcrumb.Item>
      <Breadcrumb.Item className="ms-2">
        <Icon icon="material-symbols:arrow-forward-ios-rounded" />
      </Breadcrumb.Item> */}
      <Breadcrumb.Item className="ms-2">{breadcrumb}</Breadcrumb.Item>
    </Breadcrumb>
  );
};

export default PageNav;
